'use client'

import { motion } from 'framer-motion'
import {
  MessageCircle,
  PackageSearch,
  Truck,
  RotateCcw,
  CircleHelp,
  UserCircle,
  Globe,
  Headphones,
} from 'lucide-react'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'

const tickets = [
  { icon: PackageSearch, label: 'Order tracking' },
  { icon: Truck, label: 'Shipping times' },
  { icon: RotateCcw, label: 'Returns & refunds' },
  { icon: CircleHelp, label: 'Refund status' },
  { icon: UserCircle, label: 'Account questions' },
  { icon: MessageCircle, label: 'Product questions' },
  { icon: Headphones, label: 'FAQs' },
  { icon: Globe, label: 'Multilingual support' },
]

export function AISupportSection() {
  return (
    <Section background="dark" className="relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-violet/5 rounded-full blur-3xl pointer-events-none" />

      <Container className="relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-micro-uppercase text-brand-violet mb-3">AI SUPPORT</p>
            <h2 className="text-display-1 text-ink mb-4">
              AI Support That Handles 95% of Tickets
            </h2>
            <p className="text-body-lg text-muted mb-6">
              Buddify AI automatically resolves the majority of customer inquiries — instantly and accurately. Your support inbox shrinks overnight, so you can focus on growth.
            </p>

            <ul className="space-y-3 mb-8">
              {[
                'No manual flows to build',
                'No training prompts to write',
                'Works across all languages',
                'Learns from your policies and FAQs',
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-muted">
                  <span className="w-5 h-5 rounded-full bg-brand-violet-soft text-brand-violet flex items-center justify-center text-xs">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-2 sm:grid-cols-3 gap-4"
          >
            {tickets.map((ticket, index) => {
              const Icon = ticket.icon
              return (
                <motion.div
                  key={ticket.label}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="flex flex-col items-center gap-3 p-4 rounded-xl bg-panel border border-line hover:border-brand-violet-line transition-colors"
                >
                  <Icon className="w-6 h-6 text-brand-violet" />
                  <span className="text-xs font-medium text-muted text-center">{ticket.label}</span>
                </motion.div>
              )
            })}
          </motion.div>
        </div>
      </Container>
    </Section>
  )
}
